import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { IDailyReportPreviewMemberSettings } from 'types/DailyProjectReport/DailyReportPreviewMemberSettings';
import useMemberSettings from '../member/useMemberSettings';
import useDailyReportSettingsUpdate from './useDailyReportSettingsUpdate';

export default function useDailyReportPreviewSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateDailyReportSettings = useDailyReportSettingsUpdate();

  return useCallback(
    <K extends keyof IDailyReportPreviewMemberSettings>(
      keysAndPayloads: { key: K; payload: IDailyReportPreviewMemberSettings[K] }[]
    ) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.dailyProjectReport?.dailyReportPreviewSettings);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        { ...cloned }
      );

      return updateDailyReportSettings([{ key: 'dailyReportPreviewSettings', payload: mapped }]);
    },
    [memberSettings?.web?.features?.dailyProjectReport, updateDailyReportSettings]
  );
}
